import { Grid } from '@mui/material'
import type { FC } from 'react'

import PaperedGridItem from '@/components/UI/PaperedGridItem'
import { updateExecutiveMutation } from '@/lib/apollo'
import type { Squad } from '@/utils/squad'
import { defaultGridSpacing } from '@/utils/themes'

import AdminSettingsForm from './Form'

export type Props = {
  testId: string
  userId: string
  skillLevel?: number
  squads: Squad[]
  onUpdateExecutive: (newSkillLevel: number, newSquads: Squad[]) => void
}

const AdminSettingsTab: FC<Props> = ({
  testId,
  userId,
  skillLevel,
  squads,
  onUpdateExecutive,
}) => {
  const [updateExecutive] = updateExecutiveMutation.useMutation()

  return (
    <Grid container spacing={defaultGridSpacing} data-testid={testId}>
      <PaperedGridItem xs={12}>
        <AdminSettingsForm
          skillLevel={skillLevel}
          squads={squads}
          onSaveSettings={fields => {
            const newSkillLevel = parseInt(fields.skillLevel)
            const newSquads = fields.squads

            return updateExecutive({
              variables: {
                userId,
                skillLevel: newSkillLevel,
                squads: newSquads,
              },
            }).then(() => onUpdateExecutive(newSkillLevel, newSquads))
          }}
        />
      </PaperedGridItem>
    </Grid>
  )
}

export default AdminSettingsTab
